import React from "react";
import { Box, CardContent, Grid, Typography } from "@mui/material";
import { GradientCard } from "../styles/StyledComponents";
import { kpiCards } from "../constants";

function KPICards() {
  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {kpiCards.map((card, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <GradientCard gradient={card.gradient}>
            <CardContent sx={{ position: "relative", overflow: "hidden" }}>
              <Box
                sx={{
                  position: "absolute",
                  top: -10,
                  right: -10,
                  opacity: 0.2,
                }}
              >
                {card.icon}
              </Box>
              <Box sx={{ position: "relative", zIndex: 1 }}>
                <Typography
                  variant="body2"
                  sx={{ opacity: 0.9, mb: 1, fontWeight: 500 }}
                >
                  {card.title}
                </Typography>
                <Typography variant="h3" sx={{ fontWeight: 700, mb: 0.5 }}>
                  {card.value}
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.8 }}>
                  {card.helper}
                </Typography>
              </Box>
            </CardContent>
          </GradientCard>
        </Grid>
      ))}
    </Grid>
  );
}

export default KPICards;
